import { render, staticRenderFns } from "./SetYourDomainModal.vue?vue&type=template&id=064563bd&scoped=true"
import script from "./SetYourDomainModal.vue?vue&type=script&lang=js"
export * from "./SetYourDomainModal.vue?vue&type=script&lang=js"
import style0 from "./SetYourDomainModal.vue?vue&type=style&index=0&id=064563bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064563bd",
  null
  
)

export default component.exports